// React
import { connect } from "react-redux";
import React, { Component } from "react";
// Routing
import { withRouter } from "react-router-dom";
// Material
import { withTranslation } from "react-i18next";
// Infrastructure
import { ChatsAPI } from "api/application/Chats";
// Styles
import "views/Root/application/Routes/TestChat/styles/index.scss";
import { Helmet } from "react-helmet";

class ChatWebView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      project_id: "",
      chat_id: "",
      no_credentials: false,
      config: null,
      customImageLoading: true
    };
  }

  componentDidMount() {
    this.handleData();
  }

  handleData = () => {
    var queryString = window.location.search,
      urlParams = new URLSearchParams(queryString),
      project_id = urlParams.get("project_id"),
      chat_id = urlParams.get("chat_id");

    if (project_id && chat_id) {
      this.setState({ project_id: project_id, chat_id: chat_id });
      this.getConfig(project_id, chat_id);
    } else {
      this.setState({ no_credentials: true, customImageLoading: false });
    }
  };

  getConfig = async (project_id, chat_id) => {
    const { access } = this.props.data;
    try {
      var obj = new ChatsAPI(project_id, access, { ...this.props, chat_id: chat_id });
      var config = await obj.get_chat_by_id_config();

      if (config?.background_icon) {
        this.preloadCustomImage(config);
      } else {
        this.setState({ config: config, customImageLoading: false });
      }
    } catch (err) {
      this.setState({ config: null, customImageLoading: false });
    }
  };

  preloadCustomImage = (config) => {
    const img = new Image();
    const finish = () => this.setState({ config: config, customImageLoading: false });
    img.onload = finish;
    img.onerror = finish;
    img.src = config.background_icon;
  };

  render() {
    const { project_id, chat_id, no_credentials, config, customImageLoading } = this.state;
    const customization = config?.customization || {},
      backgroundWidth = customization.background_width ?? 30,
      backgroundHeight = customization.background_height ?? 30,
      backgroundPositionX = customization.background_position_x ?? 50,
      backgroundPositionY = customization.background_position_y ?? 50,
      backgroundSrc = config?.background_icon || `${process.env.PUBLIC_URL}/background_widget.png`;

    return (
      <React.Fragment>
        {customImageLoading ? (
          <div className={"chat-view-loading"}>
            <div className={"chat-view-loading__badge"}>
              <img src={`${process.env.PUBLIC_URL}/centribal.png`} alt={"centribal_icon"} />
            </div>
          </div>
        ) : (
          <div className={"chat-view-content"}>
            <img
              className={"chat-view-content__bg"}
              src={backgroundSrc}
              alt={"centribal_background"}
              style={{
                width: `${backgroundWidth}%`,
                height: `${backgroundHeight}%`,
                left: `${backgroundPositionX}%`,
                top: `${backgroundPositionY}%`
              }}
            />
          </div>
        )}
        <Helmet>
          {project_id && chat_id && (
            <script
              id="bim-snippet"
              src={`${process.env.REACT_APP_URL_CHAT}/app/chat?key=${project_id}.${chat_id}`}
              type="text/javascript"
            ></script>
          )}
          {no_credentials && (
            <div>No hay credenciales válidas para abrir un chat</div>
          )}
        </Helmet>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const connect_chat_web = connect(mapStateToProps)(ChatWebView);

export default withTranslation("common")(withRouter(connect_chat_web));
